import { Checkbox } from 'semantic-ui-react';
import {
    useAllPossibleImportCandidateRowsSelected,
    useMetadataStoreActions,
} from '../../../../../../stores/metadataStore';
import { TableIdType } from '../../../../../../types';

type RowsInclusionTogglePropsType = {
    tableId: TableIdType;
};

const RowsInclusionToggle = ({ tableId }: RowsInclusionTogglePropsType) => {
    const { toggleTableRowsImportCandidateStatus } = useMetadataStoreActions();
    const value = useAllPossibleImportCandidateRowsSelected(tableId);

    return (
        <Checkbox
            checked={value}
            onChange={() => toggleTableRowsImportCandidateStatus(tableId)}
        />
    );
};

export default RowsInclusionToggle;
